import { fetchProviderQrInfo } from "@/api/providerDashboard";
import QRCode from "qrcode";

export default {
  async fetchQrInfo() {
    this.qrLoading = true;
    try {
      const res = await fetchProviderQrInfo();
      if (res.data.status === 200) {
        this.qrInfo = res.data.data;
        this.$nextTick(() => this.renderQr());
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.qrLoading = false;
    }
  },
  async renderQr() {
    if (!this.qrInfo.qrUrl || !this.$refs.qrCanvas) return;
    const container = this.$refs.qrCanvas;
    container.innerHTML = "";
    try {
      const canvas = document.createElement("canvas");
      await QRCode.toCanvas(canvas, this.qrInfo.qrUrl, {
        width: 160,
        margin: 1,
      });
      container.appendChild(canvas);
    } catch (e) {
      console.error("QR render failed:", e);
    }
  },
  async downloadQr() {
    if (!this.qrInfo.qrUrl) {
      this.$message.warning("QR 코드가 없습니다.");
      return;
    }
    try {
      const canvas = document.createElement("canvas");
      await QRCode.toCanvas(canvas, this.qrInfo.qrUrl, {
        width: 512,
        margin: 2,
      });
      canvas.toBlob((blob) => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `QR_${this.qrInfo.providerName}.png`;
        link.click();
        URL.revokeObjectURL(link.href);
      });
    } catch (e) {
      this.$message.error("QR 다운로드에 실패했습니다.");
    }
  },
};
